<form [formGroup]="lookupForm" (submit)="submit(lookupForm)">
  <div class="fields-container bottom-space">
    <mat-form-field appearance="outline">
      <mat-label>UMI</mat-label>
      <input required matInput formControlName="umi" type="text" placeholder="UMI">
      @if (lookupForm?.controls.umi.errors?.required) {
        <mat-error>This field is required</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Date of Birth</mat-label>
      <input required matInput [matDatepicker]="picker1" formControlName="dob" placeholder="MM/DD/YYYY">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      @if (lookupForm?.controls.dob.errors?.required) {
        <mat-error>This field is required</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="button-and-errors">
    <div class="errors">
    </div>
  </div>

  <div>
    <!-- SUBMIT -->
    @if (!showSpinner) {
      <button type="submit" mat-raised-button color="primary" [disabled]="!lookupForm?.valid "
      class="primary-btn">LOOKUP MEMBER</button>
    }
    @if (showSpinner) {
      <div>
        <mat-spinner [diameter]="36"></mat-spinner>
      </div>
    }
  </div>
</form>

@if (!showSpinner && memberLookup && !showNoMemberFound && !isPlanChange) {
  <div class="mat-typography mat-body mat-app-background top-space">
    <div>
      <div class="bottom-space">YOUR CLIENT'S MEMBER INFORMATION</div>
      <div class="queClass">Member Name</div>
      <div class="bottom-space">{{memberLookup.FIRSTNAME}} {{memberLookup.LASTNAME}}</div>
      <div class="queClass">Permanent Address</div>
      <div>{{memberLookup.PERMSTREET1}}</div>
      <div>{{memberLookup.PERMSTREET2}}</div>
      <div class="bottom-space">{{memberLookup.PERMCITY}}, {{memberLookup.PERMSTATE}} {{memberLookup.PERMZIP}}</div>
      @if (isPlanChange) {
        <div class="queClass">Existing Plan Name</div>
        <div class="bottom-space">{{memberLookup.PLANIDDESCRIPTION}}</div>
      }
    </div>
  </div>
}

@if (showNoMemberFound) {
  <mat-error class="top-space">No member was found. Please check your information and try again.</mat-error>
}
